import React, { ChangeEvent, FC } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useTranslation } from 'react-i18next';
import { Accept, useDropzone } from 'react-dropzone';

type FileDropBoxAreaProps = React.ComponentPropsWithoutRef<'div'> & {
    handleChange: (files: File[]) => void;
    accept?: Accept;
    multiple?: boolean;
};

const FileDropBoxArea: FC<FileDropBoxAreaProps> = ({ handleChange, multiple = true, accept }) => {
    const { t: translate } = useTranslation('common');
    const { getRootProps, open, getInputProps } = useDropzone({
        onDrop: handleChange,
        accept: accept,
        noClick: true,
    });

    const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
        console.log(event.target.files, 'event.target.files');
        if (event.target.files) {
            handleChange(event.target.files as unknown as File[]);
        }
    };

    return (
        <Box {...getRootProps()} onClick={open} mb={2}>
            <input {...getInputProps()} onChange={handleChangeFile} id="file-area" multiple={multiple} type="file" />
            <FileDropArea data-test="file-drop-box-area" data-testid="file-drop-box-area">
                <Box sx={{ margin: 'auto' }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <FileUploadIcon sx={{ fontSize: 50 }} />
                    </Box>
                    <Typography variant="h3" sx={{ textAlign: 'center' }}>
                        {translate('FILE_UPLOAD_INSTRUCTIONS')}
                    </Typography>
                </Box>
            </FileDropArea>
        </Box>
    );
};

const FileDropArea = styled(Box)(({ theme }) => ({
    height: 200,
    background: '#f8f8f8',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
        opacity: 0.7,
    },
}));

export default FileDropBoxArea;
